import type { UpdatePaymentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/payment';
import type { BankAccountFieldProps } from '../recoil/types/types';
import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobAtom } from '../recoil/atoms/jobAtom';
import { updatedPaymentInformationAtom } from '../recoil/atoms/updatedPaymentInformationAtom';
import { fetchedPaymentInformationAtom } from '../recoil/atoms/fetchedPaymentInformationAtom';
import { paymentFrequencyMap } from '../utils/currencyUtil';
import { useAsyncThrow } from './useAsyncThrow';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';

export function usePaymentInformationHook(): {
    updatePaymentInformation: (
        bankAccountInfo: BankAccountFieldProps,
        reThrowError: boolean
    ) => Promise<void>;
} {
    const { selectedPaymentFrequency } = useRecoilValue(jobAtom);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const { paymentMethod, bankReference, accountNumber } = useRecoilValue(
        fetchedPaymentInformationAtom
    );
    const { cpr } = useRecoilValue(updatedPaymentInformationAtom);
    const { asyncThrow } = useAsyncThrow();
    const updatePaymentInformationDto: UpdatePaymentDTO = {
        jobId: jobNumber,
        paymentMethod: paymentMethod ?? '',
        bankAccount: {
            registrationNumber: bankReference ?? '',
            accountNumber: accountNumber ?? ''
        },
        selectedPaymentFrequency: selectedPaymentFrequency ?? paymentFrequencyMap.monthly,
        cpr
    };

    const updatePaymentInformation = async (
        bankAccountInfo: BankAccountFieldProps,
        reThrowError: boolean = false
    ): Promise<void> => {
        const paymentInfo = {
            ...updatePaymentInformationDto,
            bankAccount: {
                registrationNumber: bankAccountInfo.bankReference ?? bankReference,
                accountNumber: bankAccountInfo.accountNumber ?? accountNumber
            }
        };
        await OnlineSales.updatePaymentInformation(paymentInfo, sessionId).catch((e: Error) => {
            if (reThrowError) {
                throw e;
            }
            asyncThrow(e);
        });
    };

    return { updatePaymentInformation };
}
